module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-player/player-type/player-type.component.css
// module id = ./src/app/shared/components/add-player/player-type/player-type.component.css
// module chunks = main